import { useRef, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Popup } from 'semantic-ui-react';

const messages = defineMessages({
  copy_page_link: {
    id: 'Copy page link',
    defaultMessage: 'Copy page link',
  },
  page_link_copied: {
    id: 'Page link copied!',
    defaultMessage: 'Page link copied!',
  },
});

const POPUP_DELAY = 4000;

const CopyLinkButton = ({ url }) => {
  const [isOpen, setIsOpen] = useState(false);
  const timeoutRef = useRef(null); // Ref para armazenar o timeout

  const intl = useIntl();

  const handleClick = () => {
    if (isOpen && timeoutRef.current) {
      clearTimeout(timeoutRef.current); // Limpa o timeout anterior
    }

    navigator.clipboard.writeText(url);
    setIsOpen(true);

    timeoutRef.current = setTimeout(() => {
      setIsOpen(false);
      timeoutRef.current = null; // Limpa a referência ao timeout
    }, POPUP_DELAY);
  };

  return (
    <div>
      <Popup
        content={intl.formatMessage(messages.page_link_copied)}
        open={isOpen}
        trigger={
          <button
            onClick={handleClick}
            className="br-button circle small"
            title={intl.formatMessage(messages.copy_page_link)}
          >
            <span className="fa-solid fa-link" />
          </button>
        }
        position="top center"
      />
    </div>
  );
};

export default CopyLinkButton;
